import { Col, Row } from 'antd';
import { useRoleBasedCountryFilter } from 'components/UniversalFilters/RBCountryFilter';
import { SideMarker } from 'icons-new';
import { useMemo } from 'react';
import { formatCurrencyShortened } from 'utils/helpers';
import { overdueStatusProperties, OverdueStatusPropertiesKey } from '../helper';
import { CollectionsDueResponse } from '../hooks/useDueSummaryQuery';

type DueStatusWidgetProps = {
  data?: CollectionsDueResponse[];
};

const DueStatusWidget = ({ data }: DueStatusWidgetProps) => {
  const [country] = useRoleBasedCountryFilter();
  const formattedData = useMemo(
    () => ({
      overdue: data?.filter((item) => item.dueStatus === 'overdue')?.[0]
        ?.remainingBalance,
      upcoming: data?.filter((item) => item.dueStatus === 'upcoming')?.[0]
        ?.remainingBalance,
      due_1_week: data?.filter((item) => item.dueStatus === 'due_1_week')?.[0]
        ?.remainingBalance,
      due_3_week: data?.filter((item) => item.dueStatus === 'due_3_week')?.[0]
        ?.remainingBalance,
    }),
    [data],
  );

  return (
    <Row gutter={[8, 8]}>
      {Object.keys(formattedData).map((key) => (
        <Col span={12} md={24} key={key}>
          <div className="base-card dashboard-summary-card">
            <div
              className={`card-side-marker ${overdueStatusProperties[key as OverdueStatusPropertiesKey].color}`}
            >
              <SideMarker />
            </div>
            <div className="flex-vertical card-content">
              <div className="text-base">
                {
                  overdueStatusProperties[key as OverdueStatusPropertiesKey]
                    .title
                }
              </div>
              <div className="heading-3">
                {country === 'Indonesia' && 'Rp '}
                {formatCurrencyShortened(
                  formattedData[key as OverdueStatusPropertiesKey],
                )}
                {country === 'Vietnam' && '₫'}
              </div>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default DueStatusWidget;
